<div
  class="summarize-chat-container secondary-shadow"
  [ngClass]="{ 'initialize-chat': isLoadingChat }"
>
  @if (activeIndex == 0) {
  <div
    class="search-chat-history"
    [ngClass]="{ 'show-history': isShowHistory }"
  >
    <div class="px-3 pt-2 flex justify-content-between">
      <p-button
        text="true"
        rounded="true"
        plain="true"
        styleClass="p-2 h-2rem w-2rem"
        (onClick)="isShowHistory = false"
        pTooltip="Close chat history"
      >
        <svg-icon key="delete-history"></svg-icon>
      </p-button>
    </div>
    <div>
      <app-search-chat-history
        (chatHistoryUpdate)="chatHistoryUpdate($event)"
        [getHistory]="_search.getLLMEmailHistory"
        [getHistoryByID]="_search.getLLMEmailHistoryByID"
        [maxHeight]="maxHeight"
        [doc]="data"
      ></app-search-chat-history>
    </div>
  </div>
  }
  <div class="flex-1">
    <p-accordion
      class="w-full"
      styleClass="p-0"
      (activeIndexChange)="activeIndexChange($event)"
      [activeIndex]="activeIndex"
    >
      <p-accordionTab class="p-0">
        <ng-template pTemplate="header">
          <span
            class="flex align-items-center gap-2 w-full justify-content-between"
          >
            <div>
              <div class="flex align-items-center h-2rem">
                @if (!isShowHistory && activeIndex == 0) {
                <p-button
                  text="true"
                  rounded="true"
                  plain="true"
                  styleClass="p-2"
                  pTooltip="View chat history"
                  (onClick)="
                    $event.stopImmediatePropagation(); isShowHistory = true
                  "
                >
                  <svg-icon key="history"> </svg-icon>
                </p-button>
                } @if (_auth.appConfig().brandAiAssistantIcon) {
                <img
                  [src]="_auth.appConfig().brandAiAssistantIcon"
                  alt="Assistant Icon"
                  class="assistant-icon"
                  height="20"
                />
                }@else {
                <svg-icon
                  key="book-4-spark"
                  [color]="_auth.appConfig().brandAiAssistantColor || ''"
                >
                </svg-icon>
                } @if (_auth.appConfig().brandAiAssistantName) {
                <span>
                  {{ _auth.appConfig().brandAiAssistantName }}
                </span>
                }@else {
                <span> AI Assistant </span>
                }
              </div>
              @if (subject && subject.length > 0) {
              <div class="flex align-items-center">
                <span
                  class="font-medium subject"
                  [ngClass]="{ 'ml-3': activeIndex == 0 }"
                  [pTooltip]="subjectTooltip"
                  tooltipPosition="bottom"
                >
                  {{ subject }}</span
                >
                <ng-template #subjectTooltip>
                  <div class="flex align-items-center w-20rem">
                    <span> {{subject}} </span>
                  </div>
                </ng-template>
                <app-copy-content
                  [content]="subject"
                  title="Subject"
                ></app-copy-content>
              </div>
              }
            </div>
            <div class="flex align-items-center mr-2">
              @if (!isSummaryDone) {
              <p-button
                label="Summarize"
                icon="pi pi-sparkles"
                text="true"
                (onClick)="$event.stopImmediatePropagation(); getSummary()"
              ></p-button>
              } @if (activeIndex ==0 && messages.length > 0) {
              <p-button
                text="true"
                plain="true"
                styleClass="p-2 bg-gray-100"
                pTooltip="Start a new chat"
                (onClick)="$event.stopImmediatePropagation(); startNewChat()"
              >
                New chat
                <svg-icon key="maps-ugc" class="text-lg ml-1"> </svg-icon>
              </p-button>
              }
            </div>
          </span>
        </ng-template>
        <div class="summarize-body-chat" #messageContainer>
          @if (messages.length > 0) {
          <div
            *ngFor="let message of messages; let i = index"
            class="message-container"
          >
            <span
              class="message relative"
              [ngClass]="{
                'user-message': message.role === 'user',
                'assistant-message type': message.role === 'assistant'
              }"
              style="--n: 10000"
            >
              @if (message.context && message.context.length > 0) {
              <div
                class="flex flex-column shadow-1 border-round-xl m-1 bg-gray-50 justify-content-between p-2 align-items-center mt-3"
              >
                <div
                  class="flex justify-content-between align-content-center w-full mb-1"
                >
                  <div
                    class="flex gap-1 align-content-center align-items-center"
                  >
                    <span class="font-medium">Context</span>
                  </div>
                </div>
                <div class="w-full">
                  {{ message.context }}
                </div>
              </div>
              } @if (message.content && message.content.length > 0) {
              <p [innerHTML]="message.content | sanitizer"></p>
              }@else if (message.content.length <1) {
              <p>
                <p-skeleton width="15rem" height="1rem"></p-skeleton>
                <p-skeleton
                  width="20rem"
                  styleClass="mt-2"
                  height="1rem"
                ></p-skeleton>
                <p-skeleton
                  width="25rem"
                  styleClass="mt-2"
                  height="1rem"
                ></p-skeleton>
                <p-skeleton
                  width="20rem"
                  styleClass="mt-2"
                  height="1rem"
                ></p-skeleton>
              </p>
              } @if (message.role == 'assistant' && !message.value &&
              message.content.length > 0) {
              <div
                class="message-actions-div flex justify-content-end align-items-center gap-3"
              >
                <app-copy-content
                  [content]="message.content"
                  title="content"
                ></app-copy-content>
              </div>
              }
            </span>
          </div>
          }@else {
          <div class="flex justify-content-center align-items-center mt-3">
            <p class="text-base text-l text-color-secondary">
              What can I help you with?
            </p>
          </div>
          }
        </div>
        @if (isMessageAssistantLoadedFirst) {
        <div
          class="prompt-input flex justify-content-center p-2 relative flex-column gap-2"
        >
          @if (isError) {
          <div
            class="flex align-items-center flex-column text-xs justify-content-center"
          >
            <div class="text-red-700">
              {{ errorMessage }}
            </div>
            <div class="message-regenarate">
              <p-button
                text="true"
                rounded="true"
                plain="true"
                styleClass="p-2 text-xs"
                pTooltip="Regenerate response"
                (onClick)="retry()"
                [disabled]="retryAfter > 0"
              >
                <svg-icon key="refresh" class="text-lg mr-1"> </svg-icon>
                Retry @if (retryAfter > 0) {
                <span class="text-xs text-gray-500"> ({{ retryAfter }}s) </span>
                }
              </p-button>
            </div>
          </div>
          }
          <textarea
            rows="2"
            placeholder="Type your prompt here"
            [(ngModel)]="prompt"
            class="w-full text-sm h-3rem"
            pInputTextarea
            [autoResize]="true"
            [disabled]="isMessageAssistantLoading || isLoadingChat"
            (keyup.enter)="sendMessage()"
          >
          </textarea>
          <p-button
            icon="pi pi-send"
            class="prompt-send"
            [ngClass]="{ 'prompt-active': prompt.trim().length > 0 }"
            [rounded]="true"
            styleClass="h-2rem w-2rem text-sm"
            outlined="false"
            plain="true"
            text="true"
            severity="primary"
            (onClick)="sendMessage()"
            [disabled]="
              prompt.trim().length < 1 ||
              isMessageAssistantLoading ||
              isLoadingChat
            "
          ></p-button>
          @if (messages.length > 0) {
          <div>
            <span
              class="text-gray-500 flex justify-content-center align-items-center disclaimer"
            >
              AI-generated content may be incorrect
            </span>
          </div>
          }
        </div>

        }
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
